export default defineAppConfig({
  ACCEPTED_FILE_TYPES: [
    "application/zip",
    "application/x-zip-compressed",
    "image/png",
    "image/jpeg",
    "image/gif",
    "image/webp",
    "image/avif",
    "video/mp4",
    "image/svg+xml",
    "application/mp4",
  ],
  ui: {
    colors: {
      neutral: "zinc",
      primary: "purple",
    },
    // components
    chip: {
      variants: {
        position: {
          "center-left": "left-0 top-1/2 -translate-y-1/2 -translate-x-1/2",
        },
      },
    },
    badge: {
      variants: {
        color: {
          pending: "",
          active: "",
          stale: "",
          red: "",
          orange: "",
          amber: "",
          yellow: "",
          lime: "",
          green: "",
          emerald: "",
          teal: "",
          cyan: "",
          sky: "",
          blue: "",
          indigo: "",
          violet: "",
          purple: "",
          fuchsia: "",
          pink: "",
          rose: "",
        },
      },
      compoundVariants: [
        {
          color: "active",
          variant: "solid",
          class: "bg-success text-inverted",
        },
        {
          color: "active",
          variant: "outline",
          class: "text-success ring ring-inset ring-success/50",
        },
        {
          color: "active",
          variant: "soft",
          class: "bg-success/10 text-success",
        },
        {
          color: "active",
          variant: "subtle",
          class: "bg-success/10 text-success ring ring-inset ring-success/25",
        },
        {
          color: "pending",
          variant: "solid",
          class: "bg-warning text-inverted",
        },
        {
          color: "pending",
          variant: "outline",
          class: "text-warning ring ring-inset ring-warning/50",
        },
        {
          color: "pending",
          variant: "soft",
          class: "bg-warning/10 text-warning",
        },
        {
          color: "pending",
          variant: "subtle",
          class: "bg-warning/10 text-warning ring ring-inset ring-warning/25",
        },
        {
          color: "stale",
          variant: "solid",
          class: "bg-elevated text-default",
        },
        {
          color: "stale",
          variant: "outline",
          class: "text-elevated ring ring-inset ring-default",
        },
        {
          color: "stale",
          variant: "soft",
          class: "bg-elevated/60 text-default",
        },
        {
          color: "stale",
          variant: "subtle",
          class: "bg-elevated/60 text-default ring ring-inset ring-default/25",
        },
      ],
    },
  },
});
